import { render, staticRenderFns } from "./WPButtonSlide.vue?vue&type=template&id=05e74f02"
import script from "./WPButtonSlide.vue?vue&type=script&lang=ts"
export * from "./WPButtonSlide.vue?vue&type=script&lang=ts"
import style0 from "./WPButtonSlide.vue?vue&type=style&index=0&id=05e74f02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports